export function isMobileView(medium: number = 640) {
  const screenWidth = window.innerWidth;
  return screenWidth <= medium;
}
export function parseJwt(token: string | null) {
  if (!token) {
    return {};
  }
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch {
    return {};
  }
}

export function selectObjectKeys<T extends object, K extends keyof T>(
  obj: T,
  keys: K[]
): Pick<T, K> {
  return Object.fromEntries(keys.map((key) => [key, obj[key]])) as Pick<T, K>;
}

export function excludeObjectKeys<T extends object, K extends keyof T>(
  obj: T,
  keys: K[]
): Omit<T, K> {
  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => !keys.includes(key as K))
  ) as Omit<T, K>;
}

export function numberToTurkishWords(number, currency) {
  const ones = [
    "",
    "Bir",
    "İki",
    "Üç",
    "Dört",
    "Beş",
    "Altı",
    "Yedi",
    "Sekiz",
    "Dokuz",
  ];
  const tens = [
    "",
    "On",
    "Yirmi",
    "Otuz",
    "Kırk",
    "Elli",
    "Altmış",
    "Yetmiş",
    "Seksen",
    "Doksan",
  ];
  const thousands = ["", "Bin", "Milyon", "Milyar", "Trilyon"];

  const currencySymbol = currency === 2 ? "TL" : "USD";

  if (number === 0) {
    return `Sıfır ${currencySymbol}`;
  }

  // Split the number into integer and fractional parts
  const [integerPart, fractionalPart] = number
    .toString()
    .replace(",", ".")
    .split(".");

  let words = "";
  let groupIndex = 0;
  let num = parseInt(integerPart, 10);

  while (num > 0) {
    const group = num % 1000;
    if (group > 0) {
      const groupWords = convertThreeDigitNumber(group, ones, tens);
      if (groupIndex === 1 && group === 1) {
        words = `Bin${words}`;
      } else {
        words = `${groupWords}${thousands[groupIndex]}${words}`;
      }
    }
    num = Math.floor(num / 1000);
    groupIndex++;
  }

  // Correctly handle the fractional part (e.g., "60" -> "Altmış")
  let fractionalWords = "";
  if (fractionalPart && parseInt(fractionalPart, 10) > 0) {
    const fraction = fractionalPart.padEnd(2, "0"); // Ensure two digits (e.g., "6" becomes "60")
    fractionalWords = `${convertTwoDigitNumber(parseInt(fraction, 10), ones, tens)}Kuruş`;
  }

  return `Yalnız ${words}${fractionalWords} ${currencySymbol}`;
}

function convertThreeDigitNumber(number, ones, tens) {
  const hundred = Math.floor(number / 100);
  const ten = Math.floor((number % 100) / 10);
  const one = number % 10;

  let words = "";
  if (hundred > 0) {
    words += hundred === 1 ? "Yüz" : `${ones[hundred]}Yüz`;
  }
  if (ten > 0) {
    words += `${tens[ten]}`;
  }
  if (one > 0) {
    words += `${ones[one]}`;
  }

  return words;
}

function convertTwoDigitNumber(number, ones, tens) {
  const ten = Math.floor(number / 10);
  const one = number % 10;

  let words = "";
  if (ten > 0) {
    words += `${tens[ten]}`;
  }
  if (one > 0) {
    words += `${ones[one]}`;
  }

  return words;
}
